import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4620a6b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "checkbox switch" }
const _hoisted_3 = ["checked"]
const _hoisted_4 = ["data-id", "id"]

import { onMounted } from 'vue';
import { v4 as uuidv4 } from 'uuid'

/**
 * Common input component for a custom switch using the input type
 * checkbox. Here are a few use cases:
 *  - One-way binding via :value and optionally perform additional
 *      event handling via input events
 *  - Two-way binding via v-model
 *
 * Text is slotted if necessary.
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleSwitch',
  props: {
  value: Boolean
},
  emits: ['input', 'update'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const props = __props
const updateValue = (event: Event) => {
  const value = event.target!!.checked;
  emit('input', value);
  emit('update', value);
};
const uuid = uuidv4()

onMounted(() => {
  if (props.value) {
    document.getElementById(uuid)!!.checked = true;
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _createElementVNode("input", {
        type: "checkbox",
        checked: __props.value,
        onChange: updateValue
      }, null, 40, _hoisted_3),
      _createElementVNode("span", {
        class: "slider",
        "data-id": _unref(uuid),
        id: _unref(uuid)
      }, null, 8, _hoisted_4),
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})